module.exports = __webpack_public_path__ + "img/icon.88c5134e.png";